import React from 'react';

interface FormFieldProps {
  label: string;
  children: React.ReactNode;
  error?: string;
  required?: boolean;
  className?: string;
}

const FormField: React.FC<FormFieldProps> = ({ 
  label, 
  children, 
  error, 
  required = false,
  className = ''
}) => {
  return (
    <div className={`form-group ${className}`}>
      <label className={required ? 'required' : ''}>
        {label}
        {required && <span className="required-asterisk">*</span>}
      </label>
      {children}
      {error && (
        <div className="error-message" style={{ display: 'block' }}>
          {error}
        </div>
      )}
    </div>
  );
};

export default FormField;